/** A spinner and what is loading; only while there is nothing to show yet. */
export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 py-6" role="status">
      <div className="h-5 w-5 shrink-0 animate-spin rounded-full border-2 border-line border-t-accent" />
      <p className="text-sm text-muted">{label}</p>
    </div>
  );
}

/** A load that never answered. Never shown as an empty list, and always offers Retry. */
export function LoadFailed({
  title,
  message,
  onRetry,
}: {
  title: string;
  message?: string | null;
  onRetry: () => void;
}) {
  return (
    <div
      className="note note-danger my-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
      role="alert"
    >
      <div className="min-w-0">
        <p className="text-sm font-medium text-danger">{title}</p>
        {message && <p className="mt-0.5 text-xs text-muted">{message}</p>}
      </div>
      <button type="button" onClick={onRetry} className="btn-secondary btn-sm shrink-0 self-start sm:self-auto">
        Retry
      </button>
    </div>
  );
}
